import {alertAnatomy as baseAnatomy} from '@chakra-ui/anatomy';
import {createAnatomy} from '@zag-js/anatomy';

export const alertAnatomy = createAnatomy(`alert`).parts(...baseAnatomy.keys, `content`, `actions`, `close`);

export const parts = alertAnatomy.build();

export type Part = keyof typeof parts;
